import type { GenericFunction, InventoryItem } from '@commerce-product-webcomponents/sdk';
import { IconStyle, type TabData } from '@nextgen-web-framework/all';
import type { IconName } from '@fortawesome/pro-solid-svg-icons';
import type { InventoryDataType } from './types/propsTypes';

enum stockStatusIconName {
  IN_STOCK = 'circle-check',
  LOW_STOCK = 'calendar',
  OUT_OF_STOCK = 'circle-xmark',
}

enum stockStatusEnum {
  IN_STOCK = 'IN_STOCK',
  LOW_STOCK = 'LOW_STOCK',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
}

const getStockStatusDrawerTabList = (translator: GenericFunction): TabData[] => [
  {
    title: translator('product.stockStatus.inStock'),
    id: stockStatusEnum.IN_STOCK,
    dataTabScrollId: stockStatusEnum.IN_STOCK,
    icon: stockStatusIconName.IN_STOCK,
    iconStyle: IconStyle.REGULAR,
  },
  {
    title: translator('product.stockStatus.lowStock'),
    id: stockStatusEnum.LOW_STOCK,
    dataTabScrollId: stockStatusEnum.LOW_STOCK,
    icon: stockStatusIconName.LOW_STOCK,
    iconStyle: IconStyle.REGULAR,
  },
  {
    title: translator('product.stockStatus.outOfStock'),
    id: stockStatusEnum.OUT_OF_STOCK,
    dataTabScrollId: stockStatusEnum.OUT_OF_STOCK,
    icon: stockStatusIconName.OUT_OF_STOCK,
    iconStyle: IconStyle.REGULAR,
  },
];

export const getFilterConfigs = (translator: GenericFunction, regionData: TabData[]) => [
  {
    containerLabelKey: 'product.stockStatusDrawer.productStatus',
    tabList: getStockStatusDrawerTabList(translator),
    key: 'productStatus',
  },
  {
    containerLabelKey: 'product.stockStatusDrawer.region',
    tabList: regionData ?? [],
    key: 'region',
  },
];

export const getIconConfigForStatus = (status: string): { iconName: IconName; classNamePrefix: string } => {
  switch (status) {
    case stockStatusEnum.LOW_STOCK:
      return {
        iconName: stockStatusIconName.LOW_STOCK,
        classNamePrefix: 'low-stock',
      };
    case stockStatusEnum.OUT_OF_STOCK:
      return {
        iconName: stockStatusIconName.OUT_OF_STOCK,
        classNamePrefix: 'out-of-stock',
      };
    default:
      return {
        iconName: stockStatusIconName.IN_STOCK,
        classNamePrefix: 'in-stock',
      };
  }
};

const addAClass = (regionWiseInventoryList: InventoryDataType): InventoryDataType => {
  let count = 0;
  for (const key in regionWiseInventoryList) {
    if (key) {
      for (const index in regionWiseInventoryList[key]) {
        if (index) {
          if (count % 2 !== 0) {
            regionWiseInventoryList[key][index].className = 'odd';
          }
          count++;
        }
      }
    }
  }
  return regionWiseInventoryList;
};

export const inventoryDataTransformer = (
  data: InventoryItem[],
  stockStatusFilter?: string,
): { regionWiseInventoryList: InventoryDataType; regionTabList: TabData[] } => {
  const regionTabList: TabData[] = [];
  const regionWiseInventoryList: InventoryDataType = {};
  data.forEach(({ locationName, region = '-', stockStatus }) => {
    if (!regionWiseInventoryList[region]) {
      regionWiseInventoryList[region] = [];
      regionTabList.push({
        title: region,
        id: region,
        dataTabScrollId: region,
      });
    }

    if (!stockStatusFilter || stockStatus === stockStatusFilter) {
      regionWiseInventoryList[region].push({ locationName, stockStatus, region });
    }
  });

  return { regionWiseInventoryList: addAClass(regionWiseInventoryList), regionTabList };
};
